const StentleBackendServiceFactory = ($http, endPoints, stentleConfig, NewTokenService) => {
  'ngInject';

  const url = `${endPoints.webApiUrl}stentle/picnik-rest/`;

  const urlWebApi = `${endPoints.webApiUrl}stentle/`;

  const getConfig = params => ({
    headers: {
      'X-Domain': stentleConfig.xDomain,
      'Accept-Language': 'it',
      'x-authorization-eai-idwallet': NewTokenService.getMerchantWalletID()
    },
    params
  });

  const getUrl = command => `${url}${command}`;

  const getUrlWebApi = command => `${urlWebApi}${command}`;

  const makeDeleteRequest = (c, p) => ({
    method: 'DELETE',
    url: getUrl(c),
    headers: {
      'Accept-Language': 'it',
      'Content-Type': 'application/json',
      'X-Domain': stentleConfig.xDomain,
      'x-authorization-eai-idwallet': NewTokenService.getMerchantWalletID()
    },
    data: [],
    p
  });

  const service = {
    get: (command, params) => $http.get(getUrl(command), getConfig(params)),
    post: (command, data) => $http.post(getUrl(command), data, getConfig()),
    put: (command, data) => $http.put(getUrl(command), data, getConfig()),
    delete: (command, params) => $http(makeDeleteRequest(command, params)),
    postWebApi: (command, data) => $http.post(getUrlWebApi(command), data, getConfig()),
  };

  return service;
};

export default StentleBackendServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/stentle.factory.js
 **/